import { render } from "./PoliticasView.vue?vue&type=template&id=44401508"
import script from "./PoliticasView.vue?vue&type=script&lang=js"
export * from "./PoliticasView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__